<div class="alert-list" [class.alert-list-page]="mode === 'page'">
  <div class="alert-list-toolbar">
    @if (mode === 'popup') {
      <h2 class="alert-list-title">
        <i class="fa-solid fa-bell" aria-hidden="true"></i>
        {{ 'mylists.label.alerts' | translate }}
      </h2>
    }
    <mat-checkbox
      class="unread-only"
      [ngModel]="unreadOnly"
      (ngModelChange)="setUnreadOnly($event)"
      >{{ 'alerts.label.unreadOnly' | translate }}</mat-checkbox
    >
    <span class="toolbar-spacer"></span>
    <button
      matButton
      type="button"
      class="mark-read"
      [disabled]="!unreadVisible"
      (click)="markAllAsRead()"
    >
      {{ 'mylists.action.markAlertsRead' | translate }}
    </button>
    @if (mode === 'popup') {
      <a
        class="show-all no-transform"
        routerLink="/alerts"
        (click)="alertClicked.emit()"
        >{{ 'alerts.action.showAll' | translate }}</a
      >
    }
  </div>

  <div class="alert-tabs" role="tablist" appScrollFade>
    @for (item of tabs; track item.key) {
      <button
        type="button"
        role="tab"
        class="alert-tab"
        [class.alert-tab-selected]="tab === item.key"
        [attr.aria-selected]="tab === item.key"
        (click)="selectTab(item.key)"
      >
        {{ item.label | translate }}
        <span class="alert-tab-count">{{ counts[item.key] }}</span>
      </button>
    }
  </div>

  <ul class="alert-items">
    @for (item of rows.slice(visibleAlerts); track item.alert_id) {
      <li class="alert-item" [class.alert-item-unread]="item.unread">
        <i
          class="alert-kind fa-solid"
          [ngClass]="item.type === 'companyAlert' ? 'fa-building' : 'fa-list'"
          [title]="
            (item.type === 'companyAlert'
              ? 'alerts.tab.company'
              : 'alerts.tab.list'
            ) | translate
          "
          aria-hidden="true"
        ></i>
        <a
          class="alert-main no-transform"
          [attr.href]="'#' + target(item)"
          (click)="openAlert(item, $event)"
        >
          <span class="alert-name">{{ item.name }}</span>
          <span class="alert-reason">{{ item.reason | translate }}</span>
          @if (item.type === 'listAlert' && item.company_ids.length) {
            <span class="alert-hint">{{
              'alerts.label.opensFiltered'
                | translate: { count: item.company_ids.length }
            }}</span>
          }
        </a>
        <span class="alert-date">{{ item.alert_date | date }}</span>
        <button
          type="button"
          class="read-toggle"
          [disabled]="saving.has(item.alert_id)"
          [attr.aria-label]="
            (item.unread
              ? 'alerts.action.markRead'
              : 'alerts.action.markUnread'
            ) | translate
          "
          [title]="
            (item.unread
              ? 'alerts.action.markRead'
              : 'alerts.action.markUnread'
            ) | translate
          "
          (click)="toggleRead(item)"
        >
          <i
            class="fa-envelope"
            [ngClass]="item.unread ? 'fa-solid' : 'fa-regular'"
            aria-hidden="true"
          ></i>
          <span class="read-toggle-label">{{
            (item.unread
              ? 'alerts.action.markRead'
              : 'alerts.action.markUnread'
            ) | translate
          }}</span>
        </button>
      </li>
    } @empty {
      <li class="alert-empty">
        @if ((alerts ?? []).length) {
          <p>{{ 'alerts.empty.filtered' | translate }}</p>
        } @else {
          <i class="fa-regular fa-bell-slash" aria-hidden="true"></i>
          <p class="alert-empty-title">
            {{ 'alerts.empty.title' | translate }}
          </p>
          <p>{{ 'alerts.empty.hint' | translate }}</p>
        }
      </li>
    }
    @if (rows.hasMore(visibleAlerts.length)) {
      <li
        class="load-more"
        aria-hidden="true"
        (appLoadMore)="rows.more(visibleAlerts.length)"
      ></li>
    }
  </ul>
</div>
